module.exports = __webpack_public_path__ + "static/media/step-1-colored.588d64c1.png";